module.exports = __webpack_public_path__ + "static/media/straven_4.7dbd7415.jpg";